import { useParams } from 'react-router-dom';
import MaterialsLevel from '../../../components/MaterialsLevel/MaterialsLevel';
import { PagesWrapper } from '../../../styles/components/PagesWrapper.styled';
import { useEffect, useState } from 'react';
import { fetchMaterials } from '../../../helpers/materials/fetchMaterials';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAuthMe } from '../../../redux/slices/auth';
import { useAdmin } from '../../../context/AdminInfo';

function MaterialsGroupLevel({ isAdmin }) {
  const dispatch = useDispatch();
  const { data, status } = useSelector((state) => state.auth); 
  const [loading, setLoading] = useState(false);
  const [materials, setMaterials] = useState([]);
  const { group, level } = useParams();
  const [addedLesson, setAddedLesson] = useState(false);
  // Адмін бачить матеріали мови, на яку перемкнений кабінет (adminInfo), а не мову свого акаунта
  const adminInfo = useAdmin()?.adminInfo;
  const accessType = isAdmin ? adminInfo?.accessType : data?.accessType;

  useEffect(() => {
    if (!data && status === 'loading') {
      dispatch(fetchAuthMe());
    }
  }, [dispatch, data, status]);


  useEffect(() => {
    if (!data || status !== 'success' || !accessType) return;

    const fetchData = async () => {
      setLoading(true);
      await fetchMaterials(setLoading, group, level, accessType, setMaterials, setAddedLesson);
      setLoading(false);
    };

    fetchData();
  }, [group, level, addedLesson, data, status, accessType]);

  

  return (
    <PagesWrapper>
      <MaterialsLevel
        loading={loading}
        topTitle={'Матеріали'}
        materials={materials}
        isTeacher={data?.userType === 'teacher'}
        isAdmin={isAdmin}
        setAddedLesson={setAddedLesson}
      />
    </PagesWrapper>
  );
}

export default MaterialsGroupLevel;
